import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MLayoutContentComponent } from './content.component';
import { MLayoutHeaderComponent } from './header.component';
import { MLayoutComponent } from './layout.component';
import { MLayoutMenuComponent } from './menu.component';
import { MLayoutSiderComponent } from './sider.component';

const COMPONENTS = [MLayoutComponent, MLayoutHeaderComponent, MLayoutMenuComponent, MLayoutSiderComponent, MLayoutContentComponent];

@NgModule({
  imports: [CommonModule, RouterModule, NzOutletModule, NzIconModule, NzMenuModule, TranslateModule, NzToolTipModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS]
})
export class MLayoutModule {}
